import http from '@/utils/http'

const paramsToUrlParams = obj => Object.keys(obj)
  .map(key => [key, obj[key]].join('='))
  .join('&')

const purchases = ({ params = {} }) => http()
  .get(`/stats/revenue?scope=finished&${paramsToUrlParams(params)}`)

const offersRevenue = ({ params = {} }) => http()
  .get(`/stats/offers_revenue?scope=finished&${paramsToUrlParams(params)}`)

const sessions = ({ params = {} }) => http()
  .get(`/stats/visits?${paramsToUrlParams(params)}`)

const newVsReturning = ({ params = {} }) => http()
  .get(`/stats/new_vs_returning?${paramsToUrlParams(params)}`)

const gains = ({ params = {} }) => http()
  .get(`/stats/gains?${paramsToUrlParams(params)}`)

const expertStats = ({ params = {} }) => http()
  .get(`/stats/calls?${paramsToUrlParams(params)}`)

const generalExpertStats = ({ params = {} }) => http()
  .get(`/stats/experts?${paramsToUrlParams(params)}`)

export default {
  purchases,
  offersRevenue,
  sessions,
  newVsReturning,
  gains,
  expertStats,
  generalExpertStats
}



// WEBPACK FOOTER //
// ./src/api/metrics.js